import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: any = {};

  constructor(private http: HttpClient) {}

  async loadConfig() {
    this.config = await firstValueFrom(this.http.get('/assets/config.json'));
  }

  get(key: string): any {
    return this.config[key];
  }
  getConfig(): any {
    return this.config;
  }

}
